var map = {
	"./font.css": 6955,
	"./images/color.png": 979,
	"./images/hue.png": 8520,
	"./images/snappy_bexio.svg": 1807,
	"./images/snappy_data.svg": 4192,
	"./images/snappy_ecommerce.svg": 9695,
	"./images/snappy_elements.svg": 5942,
	"./images/snappy_fintech.svg": 6094,
	"./images/snappy_flows.svg": 8814,
	"./images/snappy_invoice_automation.svg": 9860,
	"./images/snappy_llm.svg": 9890,
	"./images/snappy_pages.svg": 8133,
	"./logo.svg": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2817;